import * as React from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import modalTransition from './modal-transition'

export default function ScrollDialog({
    open,
    handleConfirm,
    handleClose,
    title,
    content,
    disableButtons,
    minHeight,
    showActions = true,
}) {
    return (
        <Dialog
            TransitionComponent={modalTransition}
            open={open}
            onClose={handleClose}
            scroll={'paper'}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
        >
            <DialogTitle id="scroll-dialog-title">{title}</DialogTitle>
            <DialogContent sx={{ minHeight: minHeight }}>
                <DialogContentText id="scroll-dialog-description" tabIndex={-1}>
                    {content}
                </DialogContentText>
            </DialogContent>
            {showActions ? (
                <DialogActions>
                    <Button disabled={disableButtons} onClick={handleClose}>
                        Cerrar
                    </Button>
                    <Button
                        disabled={disableButtons}
                        variant="contained"
                        onClick={handleConfirm}
                    >
                        Aceptar
                    </Button>
                </DialogActions>
            ) : null}
        </Dialog>
    )
}
